import styled from 'styled-components';

import Bg from '../../assets/images atp/Background.png';
import bgDesk from '../../assets/images atp/Play.webp';

export const StyledMain = styled('main')({
  height: '100%',
});
export const StyledCOntainer = styled('main')({
  height: '100%',
  backgroundImage: `url(${Bg})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100%',
  display: 'flex',
  flexDirection: 'column',
  // minHeight: '100vh',
  position: 'relative',
  backgroundAttachment: 'fixed',
  '@media screen and (max-width: 768px)': {
    backgroundColor: '#036',
  },
  '@media screen and (min-width: 768px)': {
    backgroundImage: `url(${bgDesk})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    backgroundAttachment: 'fixed',
    // backgroundPosition: 'center',
  },
});
